export interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  title?: string;
  text?: string;
  icon?: string;
  actionButtons?: React.ReactNode;
  dataTestId?: string;
  shouldCloseOnOverlayClick?: boolean;
  shouldCloseOnEsc?: boolean;
  customHeaderComponent?: React.ReactNode;
  iconStyles?: string;
  sidebar?: React.ReactNode;
  size?: string;
  children?: React.ReactNode;
  customChildrenClasses?: string;
  customContentClasses?: string;
  customHeaderClasses?: string;
}

export const ModalSize = {
  SMALL: 'w-9/12 md:w-6/12 lg:w-125',
  MEDIUM: 'w-10/12 md:w-9/12 lg:w-200',
  LARGE: 'w-11/12 xl:w-300',
};
